import { network } from 'services/network';

import { QueryFnResponse, QueryParams } from 'api/queries/getDistributionGraph.query';

export const getDistributionGraphData = (params: Omit<QueryParams, 'runQsra'>): Promise<QueryFnResponse> => {
    return network.post('api/bo/getDistributionGraphData', params).then((response) => {
        return response.data;
    });
};
